import React, {Component} from 'react';
import Aux from '../Hoc/Aux.js';
import { Cookies } from 'react-cookie';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import guideCover from '../../assets/medicare-guide-2025.png';
import guideCoverWestern from '../../assets/medicare-guide-2024-WNY.png';

class MedicareGuide extends Component {
  state = {
    url: `${process.env.REACT_APP_API_URL}/services/guide`,
    area: this.props.area,
    first_name: '',
    last_name: '',
    phone: '',
    county: '',
    email: '',
    marketingSource: '',
    formErrors: {},
    success: false,
    submitting: false
  };

  componentDidMount () {
    const cookies = new Cookies();
    const MarketingCampaignSource = (cookies.get('CDPHP_Marketing_Campaign_Source')) ? cookies.get('CDPHP_Marketing_Campaign_Source') : 'Not Set';
    this.setState({
      marketingSource: MarketingCampaignSource
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const formResults = {
      'area': this.state.area,
      'first_name': this.state.first_name,
      'last_name': this.state.last_name,
      'email': this.state.email,
      'phone': this.state.phone,
      'county': this.state.county,
      'Campaign__c': this.state.marketingSource.leadCampaign,
      'Content__c': this.state.marketingSource.leadContent,
      'Medium__c': this.state.marketingSource.leadMedium,
      'Source__c': this.state.marketingSource.leadSource,
      'GCLID__c': this.state.marketingSource.leadGCLID
    };

    console.log(formResults);
    const errors = this.validateForm(formResults);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    if (!isDisabled) {
      this.setState({submitting: true});
      console.log(formResults);
      axios.post(
        this.state.url, formResults
      ).then(response => {
        this.setState({submitting: false});
        this.setState({success: true});
        this.resetForm();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formID': 'Plans Microsite - Medicare ' + this.state.area + ' Download'
        });
      }).catch(error => {
        console.error('Error Message: ' + error);
      });
    } else {
      this.setState({formErrors: errors});
    }
  }

  validateForm (formResults) {
    let formErrors = {};

    if (formResults.first_name.length < 2) {
      formErrors.first_name = 'Required';
    }

    if (formResults.last_name.length < 2) {
      formErrors.last_name = 'Required';
    }
    if (formResults.county === '') {
      formErrors.county = 'Required';
    }

    if (!formResults.phone || formResults.phone.length < 10) {
      formErrors.phone = 'Required';
    } else if (!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(formResults.phone)) {
      formErrors.phone = 'Invalid phone number';
    }

    if (!formResults.email) {
      formErrors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formResults.email)) {
      formErrors.email = 'Invalid email address';
    }

    return formErrors;
  }

  closeForm (event) {
    this.resetForm();
    this.props.closeModal();
    var that = this;
    setTimeout(() => {
      that.setState({
        success: false
      });
    }, 500);
  }

  resetForm () {
    this.setState({
      formErrors: {},
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      county: ''
    });
  }

  render () {
    const display = (this.props.show === true ? 'show' : '');

    let counties = (
      <Aux>
        <option value='Albany'>Albany</option>
        <option value='Broome'>Broome</option>
        <option value='Chenango'>Chenango</option>
        <option value='Clinton'>Clinton</option>
        <option value='Columbia'>Columbia</option>
        <option value='Delaware'>Delaware</option>
        <option value='Essex'>Essex</option>
        <option value='Franklin'>Franklin</option>
        <option value='Fulton'>Fulton</option>
        <option value='Greene'>Greene</option>
        <option value='Hamilton'>Hamilton</option>
        <option value='Herkimer'>Herkimer</option>
        <option value='Jefferson'>Jefferson</option>
        <option value='Lewis'>Lewis</option>
        <option value='Madison'>Madison</option>
        <option value='Montgomery'>Montgomery</option>
        <option value='Oneida'>Oneida</option>
        <option value='Otsego'>Otsego</option>
        <option value='Rensselaer'>Rensselaer</option>
        <option value='Saratoga'>Saratoga</option>
        <option value='Schenectady'>Schenectady</option>
        <option value='Schoharie'>Schoharie</option>
        <option value='St. Lawrence'>St. Lawrence</option>
        <option value='Tioga'>Tioga</option>
        <option value='Warren'>Warren</option>
        <option value='Washington'>Washington</option>
      </Aux>
    );
    let guidePhoto = guideCover;
    let guideDownload = '/pdf/CDPHP_2025_Medicare_Individual_Options_Brochure.pdf';

    if (this.props.area === 'MedicareOptionsWesternNY') {
      counties = (
        <Aux>
          <option value='Allegany'>Allegany</option>
          <option value='Chemung'>Chemung</option>
          <option value='Monroe'>Monroe</option>
          <option value='Ontario'>Ontario</option>
          <option value='Schuyler'>Schuyler</option>
          <option value='Steuben'>Steuben</option>
          <option value='Yates'>Yates</option>
        </Aux>
      );
      guidePhoto = guideCoverWestern;
      guideDownload = '/pdf/CDPHP_2025_Medicare_Rochester_Plan_Options_Brochure.pdf';
    }

    let Success = null;
    if (this.state.success) {
      Success = (
        <div id='success' className={this.state.success ? 'show' : ''}>
          <div>
            <h4>Thanks!</h4>
            <p><a href={guideDownload} target='_blank' rel='noreferrer'>Download</a> your <em>{this.props.guideTitle}</em>.</p>
          </div>
        </div>
      );
    }

    return (
      <section className={'modal ' + display}>
        <div id='overlayBG' onClick={(e) => this.closeForm(e)}>
          <div id='overlay' onClick={(event) => { event.stopPropagation(); }}>
            <div className='wrap sm text-center'>
              <div className={'guide' + (this.state.submitting ? ' loading' : '')}>
                <button className='close' onClick={(e) => this.closeForm(e)}>Close</button>
                <img src={guidePhoto} alt={this.props.guideTitle} className='guide-icon medicare-icon' />
                <form onSubmit={this.handleSubmit}>
                  <h4 className='medicare'>Download the {this.props.guideTitle}.</h4>
                  <p>
                    <label>My name is</label>
                    <span className='inputContainer'>
                      <input
                        name='first_name'
                        id='first_name'
                        type='text'
                        placeholder='First'
                        className={'first_name ' + (this.state.formErrors.first_name ? 'error' : '')}
                        value={this.state.first_name}
                        onChange={this.handleInputChange} />
                    </span>
                    <span className='inputContainer'>
                      <input
                        name='last_name'
                        id='last_name'
                        type='text'
                        placeholder='Last'
                        className={'last_name ' + (this.state.formErrors.last_name ? 'error' : '')}
                        value={this.state.last_name}
                        onChange={this.handleInputChange} />
                    </span>
                  </p>

                  <p>
                    <label>My email address is</label>
                    <input
                      name='email'
                      id='email'
                      type='text'
                      className={'email ' + (this.state.formErrors.email ? 'error' : '')}
                      placeholder='you@here.com'
                      value={this.state.email}
                      onChange={this.handleInputChange} />
                  </p>

                  <p className='county'>
                    <label>My county is</label>
                    <span>
                      <select
                        name='county'
                        id='county'
                        className={'county ' + (this.state.formErrors.county ? 'error' : '')}
                        value={this.state.county}
                        onChange={this.handleInputChange}
                      >
                        <option value=''>Select County</option>
                        {counties}
                      </select>
                    </span>
                  </p>

                  <p>
                    <label>My phone number is</label>
                    <NumberFormat
                      format='(###) ###-####'
                      mask='_'
                      name='phone'
                      id='phone'
                      type='tel'
                      placeholder='(XXX) XXX-XXXX'
                      className={'phone ' + (this.state.formErrors.phone ? 'error' : '')}
                      value={this.state.phone}
                      onChange={this.handleInputChange}
                    />
                  </p>

                  <p className='pardot_extra_field'>
                    <label htmlFor='pardot_extra_field'>Comments</label>
                    <input type='text' id='pardot_extra_field' name='pardot_extra_field' />
                  </p>

                  <p className='submitForm'>
                    <input type='submit' value='Request Guide' className='btn' />
                  </p>
                </form>
              </div>
              {Success}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

MedicareGuide.propTypes = { // validate props expected
};

export default MedicareGuide;


// WEBPACK FOOTER //
// ./src/components/Forms/MedicareGuide.jsx